{
  "buildings": "Buildings",
  "building": "Building",
  "deleteBuilding": "Delete Building",
  "buildingName": "Building Name",
  "buildingAddress": "Building Address",
  "copyFromCampusAddress": "Copy from campus address",
  "floors": "Floors",
  "level": "Level",
  "floorHeightFt": "Floor Height (ft)",
  "addBuilding": "Add Building",
  "editBuilding": "Edit Building",
  "buildingUpdated": "Building updated",
  "buildingCreated": "Building created",
  "sureWantDeleteBuilding": "Deleting {{name}} building will also delete its floors, maps and annotations from the mobile app. Are you sure you want to proceed?",
  "isRoof": "Is Roof",
  "fullName": "Full Name",
  "heightFt": "Height (ft)",
  "areaSqFt": "Area (sq ft)",
  "n3dMap": "3D Map",
  "levelRequired": "Level is required",
  "levelAlreadyAssigned": "This floor level is already assigned",
  "roofLevelMin": "Roof level cannot be less than 1.",
  "levelBelowRoof": "Level must be less than Roof Level",
  "heightRequired": "Floor Height is required",
  "invalidValue": "Please enter a valid value",
  "createABuilding": "Create a Building",
  "nextCreateABuildingIn": "Next, create a building in the campus you just created.",
  "deleteFloor": "Delete Floor",
  "deleteFloorConfirm": "Deleting this floor will also delete its maps and annotations from the mobile app. Are you sure you want to proceed?",
  "more": "More",
  "floor": "Floor",
  "needAddAtLeastOneFloor": "*Need to add at least one floor.",
  "createBuilding": "Create Building"
}
